/* eslint-disable @typescript-eslint/no-unused-vars */
// Interfaces
import { CalendarOutlined, IdcardOutlined, MailOutlined } from '@ant-design/icons';

// Constants
import { LOCAL_MODE } from '../../../config';
import { PRIMARY_COLOR } from '../../../constants/colors';
import { PERMISSIONS } from '../../../constants/permissions';
import { ROUTES } from '../../../constants/routes-constants';

// Interfaces
import type { IUser } from '../../../interfaces/user';
import type { ProLayoutProps } from '@ant-design/pro-layout';

const getEventsRoutes = (_isMobile: boolean, permissions: string[]) => {
  const routes: NonNullable<ProLayoutProps['route']>[] = [];

  if (permissions.includes(PERMISSIONS.EVENTOS_CREATE) && !LOCAL_MODE) {
    routes.push({
      exact: true,
      key: 'new-event',
      name: 'Nuevo evento',
      path: ROUTES.NEW_EVENT_ROUTE
    });
  }

  if (permissions.includes(PERMISSIONS.EVENTOS_LIST)) {
    routes.push({
      exact: true,
      key: 'events-list',
      name: 'Eventos',
      path: ROUTES.EVENTS_LIST_ROUTE
    });
  }

  if (routes.length === 1) {
    const route = routes[0];
    route.icon = <CalendarOutlined style={{ color: PRIMARY_COLOR }} />;
    return route;
  }

  return {
    key: 'events',
    name: 'Eventos',
    children: routes,
    icon: <CalendarOutlined style={{ color: PRIMARY_COLOR }} />
  };
};

const getEntitiesRoutes = (_isMobile: boolean, permissions: string[]) => {
  const routes: NonNullable<ProLayoutProps['route']>[] = [];

  if (permissions.includes(PERMISSIONS.ENTIDADES_CREATE)) {
    routes.push({
      exact: true,
      key: 'new-entity',
      name: 'Nueva entidad',
      path: ROUTES.ADMIN_NEW_ENTITY_ROUTE
    });
  }

  if (permissions.includes(PERMISSIONS.ENTIDADES_LIST)) {
    routes.push({
      exact: true,
      key: 'entities-list',
      name: 'Entidades',
      path: ROUTES.ENTITIES_LIST_ROUTE
    });
  }

  if (routes.length === 1) {
    const route = routes[0];
    route.icon = <IdcardOutlined style={{ color: PRIMARY_COLOR }} />;
    return route;
  }

  return {
    key: 'entities',
    name: 'Entidades',
    children: routes,
    icon: <IdcardOutlined style={{ color: PRIMARY_COLOR }} />
  };
};

const getComunicationsRoutes = (_isMobile: boolean, permissions: string[]) => {
  const routes: NonNullable<ProLayoutProps['route']>[] = [];

  if (LOCAL_MODE) return null;

  if (permissions.includes(PERMISSIONS.COMUNICACIONES_TEMPLATE_LIST))
    routes.push({
      exact: true,
      key: 'templates',
      name: 'Plantillas',
      disabled: LOCAL_MODE,
      path: ROUTES.COMUNICATIONS_TEMPLATES_ROUTE
    });

  if (permissions.includes(PERMISSIONS.COMUNICACIONES_LIST))
    routes.push({
      exact: true,
      key: 'new-comunication',
      disabled: LOCAL_MODE,
      name: 'Comunicaciones',
      path: ROUTES.COMUNICATIONS_LIST_ROUTE
    });

  if (routes.length === 1) {
    const route = routes[0];
    route.icon = <MailOutlined style={{ color: PRIMARY_COLOR }} />;
    return route;
  }

  return {
    children: routes,
    key: 'comunications',
    name: 'Comunicaciones',
    disabled: LOCAL_MODE,
    icon: <MailOutlined style={{ color: PRIMARY_COLOR }} />
  };
};

export default (_isMobile: boolean, _user: IUser) => {
  const routes: ProLayoutProps['route'][] = [];

  const permissions =
    (_user && _user?.roles.map((r) => r.permissions?.map((p) => p.descripcion)).flat()) || [];

  // Eventos
  const eventsRoutes = getEventsRoutes(_isMobile, permissions);
  if (eventsRoutes) routes.push(eventsRoutes);

  // Entidades
  const entitiesRoutes = getEntitiesRoutes(_isMobile, permissions);
  if (entitiesRoutes) routes.push(entitiesRoutes);

  // Comunicaciones
  const comunicationsRoutes = getComunicationsRoutes(_isMobile, permissions);
  if (comunicationsRoutes) routes.push(comunicationsRoutes);

  return {
    routes
  };
};
